/** Allowlisted API `delivery_status` → `options` `Package.*` keys. */
const DELIVERY_STATUS_OPS_KEY = {
  open: "Delivery_Status.Opened",
  close: "Delivery_Status.Closed",
  deliver: "Delivery_Status.Delivered",
  return: "Delivery_Status.Returned",
};

function normalizeDeliveryStatus(raw) {
  if (raw == null) return "";
  return String(raw).trim().toLowerCase();
}

/**
 * Labels for destination package delivery status (th / en / ch via `tOps` from `options` → `Package`).
 * Thai: open → เตรียมการจัดส่ง, deliver → การจัดส่งสำเร็จ.
 * @param {string|null|undefined} rawFromApi
 * @param {string} language i18n.language
 * @param {(key: string) => string} tOpsFn from useTranslation("options", { keyPrefix: "Package" })
 * @returns {string|null} null → show "-"
 */
export function formatDeliveryStatusLabel(rawFromApi, language, tOpsFn) {
  const n = normalizeDeliveryStatus(rawFromApi);
  if (!n) return null;
  const isTh = String(language || "").toLowerCase().startsWith("th");
  if (n === "open") {
    return isTh ? "เตรียมการจัดส่ง" : tOpsFn("Delivery_Status.Opened");
  }
  if (n === "deliver") {
    return isTh ? "การจัดส่งสำเร็จ" : tOpsFn("Delivery_Status.Delivered");
  }
  const opsKey = DELIVERY_STATUS_OPS_KEY[n];
  if (!opsKey) {
    return rawFromApi != null && rawFromApi !== "" ? String(rawFromApi) : null;
  }
  return tOpsFn(opsKey);
}
